import React, { memo } from 'react';
import { CheckedRadio } from './CheckedRadio';
import { UncheckedRadio } from './UncheckedRadio';
import { RadioBtnProps } from './model/RadioBtnProps.interface';
import cls from './RadioBtn.module.css';
import cn from 'classnames';

export const RadioBtn = memo(({ isChecked, onClickHandler, fill, classes }: RadioBtnProps) => {
    return (
        <span className={cn(cls.RadioBtn, classes)}>
            {isChecked ? (
                <CheckedRadio onClick={onClickHandler} fill={fill} />
            ) : (
                <UncheckedRadio onClick={onClickHandler} fill={fill} />
            )}
        </span>
    );
});
